import React, { Component } from 'react';
import { __ } from "../Translator";
import Dropdown from "./Dropdown";
import ColorPicker from "./ColorPicker";
import { randomId } from '../Helpers';
import './TextpatchConfigurator.css';
import ColorPalette from "./ColorPalette";

// These array item will be used to style the dropdown options (.u-ff-<name>)
const FONTS = [
    { family: 'FredokaOne', lineHeight: 1.3 },
    { family: 'RaviPrakash', lineHeight: 1 },
    { family: 'Knewave', lineHeight: 1.5 },
    { family: 'Bangers', lineHeight: 1 },
    { family: 'Lobster', lineHeight: 1.3},
    { family: 'Pacifico', lineHeight: 1.8 },
    { family: 'PermanentMarker', lineHeight: 1 },
    { family: 'Fascinate', lineHeight: 1.3 },
    { family: 'LuckiestGuy', lineHeight: 1 },
    { family: 'Bungee', lineHeight: 1 },
    { family: 'Slackey', lineHeight: 1.2 },
];

class TextPatchConfigurator extends Component {
  static defaultProps = {
    onChange: console.log,
    onSetClick: console.log,
    configuration: {
      text: '',
      material: 'black',
      stroke_dimension: null,
      stroke_material: null,
      font_dimension: 'MEDIUM',
      font: FONTS[0].family,
    }
  };

  constructor(props) {
    super(props);

    this.state = {
      //patchType: '@todo Transfer',
      configuration: props.configuration,

      isTextColorPickerVisible: false,
      isStrokeColorPickerVisible: false,

      strokeSizeSelected: null,
      strokeCheck: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ configuration: nextProps.configuration });
  }

  selectedFontClick(font_dimension) {
    this.props.onChange({ font_dimension });
  }

  selectedStrokeClick(stroke_dimension) {
    if(this.state.configuration.stroke_material === null){
      this.props.onChange({ stroke_material: 'black', stroke_dimension });
    }else{
      this.props.onChange({ stroke_dimension });
    }


  }
  
  render() {
    return (
      <div>
        <div className="form-group form-group-sm">
          <div className="textPatchConfigurator__input">
            <input type="text"
               className="form-control"
               value={this.state.configuration.text}
               placeholder={__('type the text here')}
               onChange={e => this.props.onChange({ text: e.target.value })}
            />
          </div>
            <ColorPalette
              small={true}
              materials={this.props.materials}
              selected={this.state.configuration.material}
              onClick={materialKey => this.props.onChange({ material: materialKey })}
            />
        </div>

        <div className="form-group form-group-sm">
          <Dropdown
            options={FONTS.map(font => ({ value: font.family, text: __(font.family), fontClass: `u-ff-${font.family}` }))}
            selected={this.state.configuration.font}
            onChange={family => this.props.onChange({ font: family })}
          />
        </div>

        <div className="row text-center form-group-size">
          <button
            type="button"
            className={`col-xs-3 ${this.state.configuration.font_dimension === 'SMALL' ? 'is-active' : ''}`}
            onClick={() => this.selectedFontClick('SMALL')}>
            {__('SMALL')}
          </button>

          <button
            type="button"
            className={`col-xs-4 ${this.state.configuration.font_dimension === 'MEDIUM' ? 'is-active' : ''}`}
            onClick={() => this.selectedFontClick('MEDIUM')}>
            {__('MEDIUM')}
          </button>

          <button
            type="button"
            className={`col-xs-5 ${this.state.configuration.font_dimension === 'BIG' ? 'is-active' : ''}`}
            onClick={() => this.selectedFontClick('BIG')}>
            {__('BIG')}
          </button>
        </div>
        <div className="form-group-stroke">
          <h3 className="form-group--title">{__('STROKE')}</h3>
          <div className="form-group-stroke--details">
            <div className="checkbox-container">
              <input
                type="checkbox"
                id="checkbox-stroke"
                value=""
                className="form-group-stroke--checkbox"
                checked={this.state.configuration.stroke_dimension !== null}
                onChange={e => {
                  if (e.target.checked) {
                    this.props.onChange({ stroke_material: 'black', stroke_dimension: 'MEDIUM'  })
                  } else {
                    this.props.onChange({ stroke_material: null, stroke_dimension: null })
                  }
                }} />
              <label htmlFor="checkbox-stroke" className="u-fw-600"></label>
              <span>{__('Yes')}</span>
            </div>
          </div>
            <ColorPalette
              small={true}
              materials={this.props.materials}
              selected={this.state.configuration.stroke_material}
              onClick={materialKey => this.props.onChange({ stroke_material: materialKey, stroke_dimension: 'MEDIUM'  })}
            />
        </div>
        <div className="row text-center form-group-size">
          <button
            type="button"
            className={`col-xs-3 ${this.state.configuration.stroke_dimension === 'SMALL' ? 'is-active' : ''}`}
            onClick={() => this.selectedStrokeClick('SMALL')}>
            {__('SMALL')}
          </button>
          <button
            type="button"
            className={`col-xs-4 ${this.state.configuration.stroke_dimension === 'MEDIUM' ? 'is-active' : ''}`}
            onClick={() => this.selectedStrokeClick('MEDIUM')}>
            {__('MEDIUM')}
          </button>
          <button
            type="button"
            className={`col-xs-5 ${this.state.configuration.stroke_dimension === 'BIG' ? 'is-active' : ''}`}
            onClick={() => this.selectedStrokeClick('BIG')}>
            {__('BIG')}
          </button>
        </div>

        <div className="form-group">
          <button type="button" className="btn btn-primary u-w-100" onClick={() => this.props.onSetClick(this.state.configuration)} disabled={this.state.configuration.text.length === 0}>
            {__('Set')}
          </button>
        </div> 
      </div>
    );
  }
}

export default TextPatchConfigurator;
export const _FONTS = FONTS;



// WEBPACK FOOTER //
// ./src/components/TextPatchConfigurator.js